// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__+OrbY","header":"Layout_header__7wp15","contentLayout":"Layout_contentLayout__4A8qg","content":"Layout_content__3UNCT"};